import './Spinner.scss';

export const Spinner = () => (
  <div className="spinner-container">
    <div className="spinner">
      <span className="spinner__sr">Loading…</span>
    </div>
  </div>
);
